import React, { Component } from 'react';
import { fetchRssFeed } from 'components/main/common/utils';
import { parseRssData } from 'utils/rss/parseRss';
import DeviceData from 'drivers/deviceData';

/**
 * Base class for news display components.
 * Handles RSS feed fetching (via parseRssData) and keyboard scroll control.
 * Subclasses must implement render() and may use this.state.feedItems,
 * this.state.loading, this.scrollRef, and the description fallback via
 * this.props.news['locale_latest_news']?.locale_description.
 */
class BaseNewsDisplay extends Component {
  constructor(props) {
    super(props);
    this.state = {
      feedItems: [],
      loading: false,
    };
    this.scrollRef = React.createRef();
    this.handleKeyPress = this.handleKeyPress.bind(this);
  }

  componentDidMount() {
    window.addEventListener('keydown', this.handleKeyPress);
    this.loadRSSFeed();
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.handleKeyPress);
  }

  async componentDidUpdate(prevProps) {
    const prevDescription = prevProps.news?.['locale_latest_news']?.locale_description;
    const currentDescription = this.props.news?.['locale_latest_news']?.locale_description;
    if (prevDescription !== currentDescription) {
      this.loadRSSFeed();
    }
  }

  async loadRSSFeed() {
    const currentDescription = this.props.news?.['locale_latest_news']?.locale_description;
    if (!currentDescription) {
      this.setState({ feedItems: [], loading: false });
      return;
    }

    this.setState({ loading: true });
    try {
      const rssFeedData = await fetchRssFeed(currentDescription);
      this.setState({ feedItems: parseRssData(rssFeedData), loading: false });

      if (this.scrollRef.current) {
        this.scrollRef.current.scrollTop = 0;
      }
    } catch (error) {
      console.error('Error loading RSS feed:', error);
      this.setState({ feedItems: [], loading: false });
      if (this.scrollRef.current) {
        this.scrollRef.current.scrollTop = 0;
      }
    }
  }

  async handleKeyPress(event) {
    const tvKeyControls = await DeviceData.getTVControl();
    const scrollContainer = this.scrollRef.current;
    const backButton = this.props.backButtonRef?.current;
    const backButtonFocused = backButton && document.activeElement === backButton;

    if (!scrollContainer) return;

    switch (event.keyCode) {
      case tvKeyControls.KEY_UP:
        if (backButtonFocused) break;
        if (scrollContainer.scrollTop === 0 && backButton) {
          backButton.focus();
          event.preventDefault();
        } else {
          scrollContainer.scrollTop -= 50;
          event.preventDefault();
        }
        break;
      case tvKeyControls.KEY_DOWN:
        if (backButtonFocused) {
          backButton.blur();
          event.preventDefault();
        } else {
          scrollContainer.scrollTop += 50;
          event.preventDefault();
        }
        break;
      case tvKeyControls.KEY_ENTER:
        if (backButtonFocused) {
          backButton.click();
          event.preventDefault();
        }
        break;
      default:
        break;
    }
  }

  render() {
    return null;
  }
}

export default BaseNewsDisplay;
